import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';

import { withAuthorization } from '../Session';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';


const pageSizes = [7, 14, 28, 56];



export function MaterialUIPickers(props) {
    
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
    
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="none"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={new Date()}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}


function getColumns() {
    let columns = [
        {
            title: 'Date',
            field: 'Date',
            render: (row) => getFormattedDate(row.Date.substring(0,10))
            
        },
        {
            title: 'Total Money Added',
            field: 'TotalMoneyAdded',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.TotalMoneyAdded).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Total Redemption',
            field: 'TotalIssuance',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.TotalIssuance).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Total Discount',
            field: 'TotaldiscountAmount',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.TotaldiscountAmount).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Closing Balance',
            field: 'TotalWalletBalance',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.TotalWalletBalance).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Prev Closing Balance',
            field: 'PrevBalance',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.TotalPrevBalance).toFixed(2)}
                </div>
            ) 
        }
        
    ];
    return columns;
}

class DailyWalletReport extends React.Component {
    _isMounted = false;
    state = {
        perPage: 7,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        
        StartAt: [],
        moveTo: false,
        search_by: '',
        selectedItem:[],

        alert: 0,
        alertMessage: '',
        data: [],
        isLoading: true,
        search_key:this.getFormattedDate(new Date()),
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({
                isLoading: true,
            });
        }
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            customerId: this.props.UniqeID?this.props.UniqeID:this.props.user.ProfileUniqeID,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'configuration/GetDailyWalletReport'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }
                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.data.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data:responseData.data,
                            isLoading: false,
                            alert: 0
                        });
                    }    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({search_by:'Date', moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: this.getFormattedDate(new Date()),
            search_by:'',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ isLoading: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ isLoading: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

   
    
    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

   
    render() {
        

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}
                {this.state.alert === 2 && (
                    <Alert variant="sucess">{this.state.alertMessage}</Alert>
                )}

                {this.state.isLoading && <Spinner animation="border" />}

                <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Daily Wallet Report
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    
                                    
                                    <Row style={{ marginLeft: '0px',marginRight: '0px' }}>
                                    <Col>
                                        <MaterialUIPickers
                                        id="date-picker-inline1"
                                        label="Select Date"
                                        setDate={(date) => {
                                            this.setState({
                                                search_key: this.getFormattedDate(date)
                                            });
                                        }}
                                    />
                                    </Col>
                                    </Row>
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        {this.state.data &&<MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Summary"
                            columns={getColumns()}
                            data={this.state.data}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />}

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                        
                
            </Container>
        );
    }
}


const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(DailyWalletReport);
